<template>
  <view class="u-page">
    <u-swiper :list="list1" :radius="0" height="187"></u-swiper>
    <view v-if="indexList.length > 0">
      <view v-for="(item, index) in indexList" :key="index">
        <u-cell :title="item.title" :name="item.id" :label="`发布时间：${$u.timeFormat(item.createTime, 'yyyy-mm-dd hh:MM:ss')}`"  :clickable="true"
                @click="goToDetail"></u-cell>
      </view>
      <view class="u-p-b-20 u-m-t-20">
        <u-loadmore :status="load.status" color="#999999" :icon-type="load.icon" :load-text="load.text"></u-loadmore>
      </view>
    </view>
    <view v-else style="margin-top: 25%;">
      <u-empty mode="news" text="暂无公告信息"></u-empty>
    </view>
  </view>
</template>

<script>
import {getBannerList} from "@/common/api";
import config from "@/config"
import {getNoticeList} from "../../common/api";
export default {
  name: "index",
  data(){
    return{
      list1: [],
      indexList: [],
      queryForm:{
        pageNum:1,
        pageSize:10,
      },
      load:{
        status: 'loadMore',
        icon: 'flower',
        text:{
          loadmore: '上拉加载',
          loading:'努力加载中',
          nomore : '没有更多数据了'
        }
      },
    }
  },
  onLoad(){
    uni.setNavigationBarTitle({ title: '园区公告',})
    this.getBanners();
    this.getApiPage();
  },
  //底部触发
  onReachBottom(){
    if (this.load.status !== 'nomore'){
      this.load.status = 'loading';
      this.queryForm.pageNum = this.queryForm.pageNum +1;
      this.getApiPage();
    }
  },
  methods: {
    goToDetail(e){
      this.$u.route({url:'pages/announcement/detail',params:{id:e.name}});
    },
    getBanners() {
      getBannerList().then(res=>{
        if (res.length > 0){
          this.list1 = res.map(item =>{
            return config.imageUrlYL+item.dataValue
          })
        }
      })
    },
    getApiPage() {
      const _this = this;
      getNoticeList(_this.queryForm).then(res=>{
        this.$nextTick(()=>{
          if (_this.queryForm.pageNum === 1){
            _this.indexList = res.rows;
          }else{
            _this.indexList.push(...res.rows);
          }
          this.$forceUpdate();
        })
        if (res.haveNextPage && this.queryForm.pageSize === res.rows.length){
          this.load.status = 'loadmore';
        }else{
          this.load.status = 'nomore';
        }
      })
    }
  },
}
</script>

<style scoped>

</style>
